import { taskmanager } from '@/http';
import firmwareStatusMock from '@/modules/monitoring/__mocks__/firmware-status-mock.json';

const isLocal = () => window.__env?.back_end?.enviroment === 'local';

function randomMock() {
  const items = firmwareStatusMock.responses;
  return items[Math.floor(Math.random() * items.length)];
}

class TaskManagerService {
  /**
   * Paginated task search.
   * @param {{ imei?: string, taskType?: string, page?: number, pageSize?: number }} params
   */
  async searchTasks({ imei, taskType, page = 0, pageSize = 20 } = {}) {
    const body = {}
    if (imei)     body.imei     = imei
    if (taskType) body.taskType = taskType
    body.page     = page
    body.pageSize = pageSize
    return await taskmanager.post('/tasks/search', body)
  }

  /**
   * Firmware status for a device.
   * GET /basestation-version/{imei} — requires Referer header (shard identification).
   *
   * Mapped states:
   *   200 success=true  → state from backend (SETTLED | OUTDATED | TEST_DEVICE), version, expectedVersion
   *   200 success=false → UNKNOWN
   *   404               → NOT_FOUND
   *   500               → ERROR
   *   expectedVersion null → AUTO_UPDATE_DISABLED
   *
   * @param {string} imei
   * @returns {{ state: string|null, version: string|null, expectedVersion: string|null, error: string|null }}
   */
  async getFirmwareStatus(imei) {
    if (isLocal()) return randomMock();

    try {
      const { data } = await taskmanager.get(`/basestation-version/${imei}`, {
        headers: { Referer: window.location.origin },
      });

      const expectedVersion = data.expectedVersion ?? null;
      const state = expectedVersion === null && data.state !== 'AUTO_UPDATE_DISABLED'
        ? 'AUTO_UPDATE_DISABLED'
        : (data.state ?? null);

      return { state, version: data.version ?? null, expectedVersion, error: data.error ?? null };

    } catch (err) {
      const status = err?.response?.status;
      const state  = status === 404 ? 'NOT_FOUND' : 'ERROR';
      return { state, version: null, expectedVersion: null, error: err?.message ?? null };
    }
  }
}

export default new TaskManagerService()
